<template>
    <div class="display-wrapper fullscreen-wrapper">
        <fullscreen :fullscreen.sync="isFullscreen">
            <div class="display-content" v-if="toReload">
                <div class="column left">
                    <!-- 培训班统计 -->
                    <div class="row class-all">
                        <div class="row-content" style="padding: 1.25rem">
                            <div class="row-title">{{ year }}年等级培训班统计 <span class="title" style="color: #FAC858; margin-left: 2rem">总数量： <span style="font-size:18px">{{numStatisticalAll}} </span></span><span class="sutNum" v-if="numStatisticalStuAll">/ {{numStatisticalStuAll}}人</span></div>
                            <div class="data-wrapper" style="display:block;">
                                <div style="display:flex">
                                    <div :class="{'data-item':true, tooltip : numStatisticalStu.D }">
                                        <div class="data num_data">{{ numStatistical.D }}</div>
                                        <div class="data-title">D级</div>
                                        <div class="tooltiptext">
                                            <div>{{ numStatisticalStu.D }} 人</div>
                                        </div>
                                    </div>
    
    
                                    <div :class="{'data-item':true, tooltip : numStatisticalStu.C }">
                                        <div class="data num_data">{{ numStatistical.C }}</div>
                                        <div class="data-title">C级</div>
                                        <div class="tooltiptext">
                                            <div>{{ numStatisticalStu.C }} 人</div>
                                        </div>
                                    </div>
                                    <div :class="{'data-item':true, tooltip : numStatisticalStu.B }">
                                        <div class="data num_data">{{ numStatistical.B }}</div>
                                        <div class="data-title">B级</div>
                                        <div class="tooltiptext">
                                            <div>{{ numStatisticalStu.B }} 人</div>
                                        </div>
                                    </div>
                                    <div :class="{'data-item':true, tooltip : numStatisticalStu.A }">
                                        <div class="data num_data">{{ numStatistical.A }}</div>
                                        <div class="data-title">A级</div>
                                        <div class="tooltiptext">
                                            <div>{{ numStatisticalStu.A }} 人</div>
                                        </div>
                                    </div>
                                    <div :class="{'data-item':true, tooltip : numStatisticalStu.PRO }">
                                        <div class="data num_data">{{ numStatistical.PRO }}</div>
                                        <div class="data-title">职业级</div>
                                        <div class="tooltiptext">
                                            <div>{{ numStatisticalStu.PRO }} 人</div>
                                        </div>
                                    </div>
                                </div>
                                <div style="display:flex;margin-top:5px">
                                    <div :class="{'data-item':true, tooltip : numStatisticalStu.GC }">
                                        <div class="data num_data">{{ numStatistical.GC }}</div>
                                        <div class="data-title">守门员C级</div>
                                        <div class="tooltiptext">
                                            <div>{{ numStatisticalStu.GC }} 人</div>
                                        </div>
                                    </div>
                                    <div :class="{'data-item':true, tooltip : numStatisticalStu.GB }">
                                        <div class="data num_data">{{ numStatistical.GB }}</div>
                                        <div class="data-title">守门员B级</div>
                                        <div class="tooltiptext">
                                            <div>{{ numStatisticalStu.GB }} 人</div>
                                        </div>
                                    </div>
                                    <div :class="{'data-item':true, tooltip : numStatisticalStu.GA }">
                                        <div class="data num_data">{{ numStatistical.GA }}</div>
                                        <div class="data-title">守门员A级</div>
                                        <div class="tooltiptext">
                                            <div>{{ numStatisticalStu.GA }} 人</div>
                                        </div>
                                    </div>
                                    <div :class="{'data-item':true, tooltip : numStatisticalStu.F1 }">
                                        <div class="data num_data">{{ numStatistical.F1 }}</div>
                                        <div class="data-title">体能L1级</div>
                                        <div class="tooltiptext">
                                            <div>{{ numStatisticalStu.F1 }} 人</div>
                                        </div>
                                    </div>
                                    <div :class="{'data-item':true, tooltip : numStatisticalStu.F2 }">
                                        <div class="data num_data">{{ numStatistical.F2 }}</div>
                                        <div class="data-title">体能L2级</div>
                                        <div class="tooltiptext">
                                            <div>{{ numStatisticalStu.F2 }} 人</div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <!-- 培训班监控 | 成绩监控-->
                    <div class="row class-table">
                        <div class="row-content">
                            <div class="nav-title-wrapper">
                            <span class="nav-item " :class="{'active-title':classNav === 0}"
                                  @click="handleClassNavClick(0)">教练员</span>
                                <span class="nav-item " :class="{'active-title':classNav === 1}"
                                      @click="handleClassNavClick(1)">讲师</span>
                                <span class="nav-item " :class="{'active-title':classNav === 2}"
                                      @click="handleClassNavClick(2)">培训班</span>
                                <span class="nav-item " :class="{'active-title':classNav === 3}"
                                      @click="handleClassNavClick(3)">成绩</span>
                                <span style="color: #FFDC60;">行为监控条数：{{ actionOnline }}</span>
                            </div>
                            <div class="table-wrapper">
                                <div class="table-head" v-if="classNav === 0 || classNav === 1">
                                    <div class="table-column" style="flex: 1">操作时间</div>
                                    <div class="table-column" style="flex: 1">姓名</div>
                                    <div class="table-column" style="flex: 1">内容</div>
                                </div>
                                <div class="table-content" v-if="classNav === 0 || classNav === 1">
                                    <div class="animation-wrapper">
                                        <div class="table-row" v-for="(item,index) in classStatusList" :key="'up' + index">
                                            <div class="table-col" style="flex: 1;" :title="item.time | time ">{{item.time |
                                                time }}
                                            </div>
                                            <div class="table-col" style="flex: 1;" :title="item.name">{{ item.name }}</div>
                                            <div class="table-col" style="flex: 1;" :title="item.msg">{{ item.msg }}
                                            </div>
                                        </div>
                                        <!-- 为了动画问题 -->
                                        <div class="table-row" v-for="(item,index) in classStatusList" :key="'down' + index">
                                            <div class="table-col" style="flex: 1;" :title="item.time | time ">{{item.time |
                                                time }}
                                            </div>
                                            <div class="table-col" style="flex: 1;" :title="item.name">{{ item.name }}</div>
                                            <div class="table-col" style="flex: 1;" :title="item.msg">{{ item.msg }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="table-head" v-if="classNav === 2 || classNav === 3">
                                    <div class="table-column">操作时间</div>
                                    <div class="table-column">培训班名称</div>
                                    <div class="table-column">操作类型</div>
                                    <div class="table-column">状态</div>
                                    <div class="table-column">内容</div>
                                </div>
                                <div class="table-content" v-if="classNav === 2 || classNav === 3">
                                    <div class="animation-wrapper">
                                        <div class="table-row" v-for="(item,index) in classStatusList" :key="'up' + index">
                                            <div class="table-col" :title="item.update_time | time ">{{item.update_time |
                                                time }}
                                            </div>
                                            <div class="table-col" :title="item.name">{{ item.name }}</div>
                                            <div class="table-col" :title="item.type | formateType">{{ item.type |
                                                formateType }}
                                            </div>
                                            <div class="table-col" :title="item.status | formateStatus">{{ item.status |
                                                formateStatus }}
                                            </div>
                                            <div class="table-col" :title="item.opinion">{{ item.opinion || '--' }}</div>
                                        </div>
                                        <!-- 为了动画问题 -->
                                        <div class="table-row" v-for="(item,index) in classStatusList" :key="'down' + index">
                                            <div class="table-col" :title="item.update_time | time ">{{item.update_time |
                                                time }}
                                            </div>
                                            <div class="table-col" :title="item.name">{{ item.name }}</div>
                                            <div class="table-col" :title="item.type | formateType">{{ item.type |
                                                formateType }}
                                            </div>
                                            <div class="table-col" :title="item.status | formateStatus">{{ item.status |
                                                formateStatus }}
                                            </div>
                                            <div class="table-col" :title="item.opinion">{{ item.opinion || '--' }}</div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="column center">
                    <div class="map-canvas" style="position: relative">
                        <!--                    <div class="online row" style="width: 100px; height: 100px;">-->
                        <!--                        <div class="online-content">-->
                        <!--                            <div class="title">在线人数</div>-->
                        <!--                            <div class="content">-->
                        <!--                                {{ onlineCount }}-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <!--                    </div>-->
                        <div style="width: 100%; display: flex; justify-content: center; align-items: center;position: absolute;top: -44px;left: 0" >
                            <span @click="toggleApi">
                                <span class="fullscreen-btn" v-if="!fullscreen">全屏</span>
                                <span class="fullscreen-btn" v-else>退出全屏</span>
                            </span>
                        </div>
                        <div class="map-title">{{year}}年各省/自治区/直辖市/特别行政区开班数量</div>
                        <div class="select-wrapper" style="position: absolute;top: 0px;right: -6px;z-index: 999; width: 120px">
                            <el-select v-model="year"  v-loading.fullscreen.lock="fullscreenLoading"  @change="yearChange" style="width: 100%;height: 100%;background-color: rgba(0,0,0,0)">
                                <el-option
                                  v-for="item in yearList"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                            <div id="echart-map" key="system-map" ref="echart-map" class="echart-map">
                                <div class="echart-geo"></div>
                            </div>
                    </div>
                </div>
                <div class="column right">
                    <div class="row tutorial-all class-all">
                        <div class="row-content">
                            <div class="row-title">全部教案统计</div>
                            <div class="data-wrapper" style="margin-top: 1.5em">
                                <div class="data-item">
                                    <div class="data">{{ allTutorial }}</div>
                                    <div class="data-title">教案总数</div>
                                </div>
                                <div class="data-item">
                                    <div class="data">{{ planCount.exam }}</div>
                                    <div class="data-title">考试教案数量</div>
                                </div>
                                <div class="data-item">
                                    <div class="data">{{ planCount.practice }}</div>
                                    <div class="data-title">实践教案数量</div>
                                </div>
                                <div class="data-item">
                                    <div class="data">{{ planCount.excellent }}</div>
                                    <div class="data-title">优秀教案数量</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row class-all tutorial-add">
                        <div class="row-content">
                            <div class="row-title">
                                <span>{{year}}年教练员成绩分析</span>
                                <!--                            <span class="btn" :class="{ 'btn-active': tutorialAddedNav === 'week'}"-->
                                <!--                                  @click="handleAddedTutorialChange('week')">周</span>-->
                                <!--                            <span class="btn" :class="{ 'btn-active': tutorialAddedNav === 'month'}"-->
                                <!--                                  @click="handleAddedTutorialChange('month')">月</span>-->
                                <!--                            <span class="btn" :class="{ 'btn-active': tutorialAddedNav === 'year'}"-->
                                <!--                                  @click="handleAddedTutorialChange('year')">年</span>-->
                            </div>
                            <div class="data-wrapper">
                                <div class="echart-tutorial-add" id="echart-tutorial-add"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="display-content" v-if="toReload" style="background:none;padding:0 0.8rem">
                <div class="column">
                    <!-- 会员协会培训班统计 -->
                    <div class="row class-all class-vip">
                        <div class="row-content">
                            <div class="row-title">
                                <span>{{year}}年会员协会培训班统计</span>
                            </div>
                            <div class="data-wrapper" style="position: relative">
                                <div class="select-wrapper" style="position: absolute;top: -25px;right: -6px;z-index: 999; width: 120px">
                                    <el-select v-model="selectCoachIndex" @change="coachChange" style="width: 100%;height: 100%;background-color: rgba(0,0,0,0)">
                                        <el-option
                                          v-for="item in coachList"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="echart-class-status" id="echart-class-status"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column" style="margin: 0 0 0 1.5rem">
                    <div class="row class-all user-all" style="flex:1">
                        <div class="row-content">
                            <div class="flex-box" style="width: 100%;height: 100%">
                                <div class="flex-item left">
                                    <div class="row-title">
                                        <span>等级教练员数据</span>
                                        <span style="margin-left:20px;color:#61a8ff;font-size:14px">注册教练员总量</span>
                                        <span style="margin-left:5px;color:white">{{ allCoachName || "0" }}</span>
                                    </div>
                                    <div class="data-wrapper">
                                        <div class="echart-associate-all" id="echart-associate-all"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column" style="margin: 0 1.5rem">
                    <div class="row class-all user-all">
                        <div class="row-content">
                            <div class="flex-box" style="width: 100%;height: 100%">
                                <div class="flex-item left">
                                    <div class="row-title">
                                        <span>专项教练员数据</span>
                                        <span style="margin-left:10px;color:#61a8ff;font-size:14px">总注册</span>
                                        <span style="margin-left:5px;color:white">{{ allCoachNamezhuanxiang + allCoachNamePhysical }}</span>
                                        <span style="margin-left:10px;color:#61a8ff;font-size:14px">守门员教练</span>
                                        <span style="margin-left:5px;color:white">{{ allCoachNamezhuanxiang || "0" }}</span>
                                        <span style="margin-left:10px;color:#61a8ff;font-size:14px">体能教练</span>
                                        <span style="margin-left:5px;color:white">{{ allCoachNamePhysical || "0" }}</span>
                                    </div>
                                    <div class="data-wrapper">
                                        <div class="echart-associate-all" id="echart-associate-all1"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="row class-all login-data">
                        <div class="row-content">
                            <div class="row-title">
                                <span>登录统计</span>
                                <span class="btn" :class="{ 'btn-active': userLoginNav === 'day'}"
                                  @click="handleLoginDataNavChange('day')">“日”登录量</span>
                                <!-- <span class="btn" :class="{ 'btn-active': userLoginNav === 'week'}"
                                      @click="handleLoginDataNavChange('week')">7日登录量</span> -->
                                <span class="btn" :class="{ 'btn-active': userLoginNav === 'month'}"
                                  @click="handleLoginDataNavChange('month')">“月”登录量 </span>
                                <span class="btn" :class="{ 'btn-active': userLoginNav === 'year'}"
                                  @click="handleLoginDataNavChange('year')">“年”登录量</span>
                                <span class="title" style="color: #FAC858; margin-left: 2rem">在线： {{ onlineCount }}人</span>
                                
                            </div>
                            <div class="data-wrapper">
                                <div class="echart-user-login" id="echart-user-login"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </fullscreen>
    </div>
</template>

<script>
    import echarts from 'echarts';
    import {nameMap} from "./mapJSON/nameMap";
    // import 'echarts/map/js/china';
    import 'echarts/extension/bmap/bmap';
    import {debounce} from '../../assets/js/utils';
    import {
        getDisplayClassAllInfo,
        getDisplayClassTable,
        getTutorialAll,
        getUserLoginData
    } from '../../api/display';
    import VueFullscreen from 'vue-fullscreen'
    import Vue from 'vue'
    
    Vue.use(VueFullscreen);


    var moment = require('moment');

    export default {
        name: "Display",
        created() {
            this.year = new Date().getFullYear();
        },
        computed: {
//            year() {
//                let year = new Date().getFullYear()
//                this.year = year;
////                return year;  // 如果有需求，返回当前年份，非固定
//            },
            numStatisticalAll() {
                let allCounts = 0;
                for (let key in this.numStatistical) {
                    allCounts += this.numStatistical[key]
                }
                return allCounts
            },
            numStatisticalStuAll() {
                let allCounts = 0;
                for (let key in this.numStatisticalStu) {
                    allCounts += this.numStatisticalStu[key]
                }
                return allCounts
            },
            allTutorial() {
                let {exam, practice} = this.planCount;
                return (exam + practice) || 0;
            },
            onlineCount() {
                if(this.onlineCoachCount.length) {
                    return  this.onlineCoachCount[0].num || 0
                } else {
                    return  0
                }
            },
            actionOnline() {
                if(this.eventCoachCount.length) {
                    return  this.eventCoachCount[0].num || 0
                } else {
                    return  0
                }
            },
            // 获取2019年至今的年份数组
            yearList(){
                let year = new Date().getFullYear();
                let yearList = [];
                for(var i = 0; i <= (year-2019); i++ ){
                    yearList.push(
                      {value:(2019+i), label:(2019+i)},
                    );
                }
                return  yearList;
            }
        },

        watch: {
            // 培训班监控
            // 'classNav': function (newVal, oldVal) {
            // },
            // 新增教案统计
            'tutorialAddedNav': function (newVal, oldVal) {
                this.formateData2EchartsLine(newVal);   // 避免出错，切换即调用
                this.draw_tutorial_add(newVal)
            },
            // 用户登录数量统计
            'userLoginNav': function (newVal, oldVal) {
                if(newVal!==0) {
                    this.formateLoginData2EchartsLineData(newVal);
                }
                this.draw_user_login(newVal);
            },
            // 监测协会列表显示内容
            'selectCoachIndex': function (newVal, oldVal) {
                // if( newVal !== 0 ) {
                    this.draw_class_status();
                // }
            }

        },

        data() {
            return {
                fullscreenLoading: false,
                fullscreen: false,
                teleport: true, //
                isFullscreen: false,
                userLoginTimer: null,   // 自动切换定时器
                clickTimer: null, //  点击定时器
                tutorialTimer: null,
                count: 0,
                echartsList: [],
                toReload: true,
                year:'',
                numStatistical: {
                    Audit: 0,       // 审核中
                    Complete: 0,    // 已完成
                    Finalised: 0,   // 成绩未提交
                    Incomplete: 0,  // 进行中
                    Initiated: 0,   // 未开始
                    ScoreAudit: 0,  // 成绩审核中
                }, // 等级培训数据
                numStatisticalStu: {
                
                },
                classNav: 0,
                tutorialAddedNav: 'week',
                userLoginNav: 'day',
                dataClass: [],   // 培训班监控
                dataScore: [],   // 成绩监控
                onlineCoachCount: [],  // 在线人数
                eventCoachCount: [],    // 行为监控
                coachMonitoring: [],    // 教练监控
                teacherMonitoring: [],  // 讲师监控
                vipClassEchartsData: {},
                echartsBarYData: {},
                echartsBarX: [],
                coachList: '',

                loginInfoCount: {}, // 用户登录数量统计 原始数据
                coachCount: {}, // 教练员成绩数据，包括，职业，A,B,C,D级通过人数，未通过人数，总人数；
                userCount: {}, // 会员协会用户量统计
              allCoachName: 0, // 会员协会用户量统计
              allCoachNamezhuanxiang: 0, // 守门员数量
              allCoachNamePhysical: 0, // 体能数量
                loginEchartData: {
                    xAxisData: [],
                    seriesData: []
                }, // 用户登录数量统计 处理之后的数据
                userInfoOrganization: [],    // 会员协会图表统计 原始数据
                vipUserCountEchartData: {xAxisData: [], seriesData: []}, // 会员协会图表统计 处理数据
                vipUserCountEchartDataZhuanxiang: {xAxisData: [], seriesData: []}, // 会员协会图表统计 处理数据

                planCount: {
                    exam: 0,
                    practice: 0,
                    excellent: 0
                },  // 教案统计
                planInfo: [],  // 教案统计 - 年
                planInfoEchartsRenderData: {
                    x_data: [],
                    source_map_exam_series: [],
                    source_map_practice_series: []
                },  // 新增教案统计，渲染用数据
                echartsLineXData_exam: [],

                echartsLineSeriesData_exam: [],

                classStatusList: [],

                selectCoachIndex: 0,    // 会员协会培训班统计默认培训班选择
                coachAutoChangeTimer: null, // 会员协会默认切换
                changeTimer: null,
                tableTimer: null,   // 培训班监控定时器

                chinaMapOption: {
                    notMerge: true,
                    backgroundColor: '#080a20',
                    tooltip: {
                        trigger: 'item'
                    },
                    visualMap: {//颜色的设置  dataRange
                        textStyle: {color: '#fff'},
                        x: 'left',
                        y: 'bottom',
                        splitList: [
                            {start: 51 }, {start: 41, end: 50},
                            {start: 31, end: 40}, {start: 21, end: 30},
                            {start: 11, end: 20}, {start: 6, end: 10},
                            {start: 1, end: 5},{start: 0, end: 0},
                        ],
                        // text:['高','低'],// 文本，默认为数值文本
                        // color: ['#65A2D9', '#E09107', '#A3E00B']
                        color: ['#FF0000', '#FFA500', '#FFFF00', '#00FF00', '#0000FF', '#007FFF', '#8B00FF', '#FFFFFF']
                    },
                    roamController: {   //控制地图的上下左右放大缩小
                        show: true,
                        x: 'right',
                        mapTypeControl: {
                            'china': true
                        }
                    },
                    series: [
                        {
                            name: '本地开班数量',
                            type: 'map',
                            mapType: '中国地图',
                            // mapType: 'china',
                            // zoom: 1.2,
                            zoom: 1.4,
                            roam: true,    //是否开启鼠标缩放和平移漫游
                            itemStyle: {     //地图区域的多边形 图形样式
                                normal: {    //是图形在默认状态下的样式
                                    label: {
                                        show: true,
                                        textStyle: {color: "rgb(0, 0, 0)"}
                                    },
                                    areaColor: '#fff',
                                    borderColor: '#0692a4'
                                },
                                emphasis: {  //是图形在高亮状态下的样式,比如在鼠标悬浮或者图例联动高亮时
                                    label: {show: true},
                                }
                            },
                            // top: "20",  //组件距离容器的距离
                            top: 130,  //组件距离容器的距离
                            data: [],
                            // nameMap: {
                            //     '上海市': '上海',
                            //     '北京市': '北京',
                            //     '重庆市': '重庆',
                            //     '天津市': '天津',
                            // }
                            nameMap: nameMap,
                        }
                    ]
                },

                // 百度地图
                bmapOption: {
                    title: {
                        text: '',
                        subtext: '',
                        sublink: '',
                        left: 'center'
                    },
                    visualMap: {//颜色的设置  dataRange
                        textStyle: {color: '#fff'},
                        x: 'left',
                        y: 'bottom',
                        splitList: [
                            {start: 1500}, {start: 900, end: 1500},
                            {start: 310, end: 1000}, {start: 200, end: 300},
                            {start: 50, end: 200}, {start: 0, end: 50},
                        ],
                        // text:['高','低'],// 文本，默认为数值文本
                        // color: ['#65A2D9', '#E09107', '#A3E00B']
                        color: ['#5475f5', '#9feaa5', '#3FA7FF', '#66E0E3', '#FFDC5E', '#9fb5ea']
                    },
                    aria: {
                        decal: {
                            decals: [
                                {
                                    color: "rgba(0,0,0,0.2)",
                                    dashArraX: [1, 0],
                                    dashArraY: [2, 5],
                                    symbolSize: 1,
                                    roration: 0.5235987755982988
                                }
                            ]
                        }
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    /*
                    * areaColor: '#142957',
                                    borderColor: '#0692a4'
                    * */
                    bmap: {
                        center: [104.114129, 37.550339],
                        zoom: 5,
                        roam: true,
                        mapStyle: {
                            styleJson: [{
                                'featureType': 'water',
                                'elementType': 'all',
                                'stylers': {
                                    'color': '#68d8fe'
                                }
                            }, {
                                'featureType': 'land',
                                'elementType': 'all',
                                'stylers': {
                                    'color': '#142957'
                                }
                            }, {
                                'featureType': 'railway',
                                'elementType': 'all',
                                'stylers': {
                                    'visibility': 'off',
                                }
                            }, {
                                'featureType': 'highway',
                                'elementType': 'all',
                                'stylers': {
                                    'visibility': 'off',
                                    'color': '#fdfdfd'
                                }
                            }, {
                                'featureType': 'highway',
                                'elementType': 'labels',
                                'stylers': {
                                    'visibility': 'off'
                                }
                            }, {
                                'featureType': 'arterial',
                                'elementType': 'geometry',
                                'stylers': {
                                    'visibility': 'off',
                                    'color': '#fefefe'
                                }
                            }, {
                                'featureType': 'arterial',
                                'elementType': 'geometry.fill',
                                'stylers': {
                                    'visibility': 'off',
                                    'color': '#fefefe'
                                }
                            }, {
                                'featureType': 'poi',
                                'elementType': 'all',
                                'stylers': {
                                    'visibility': 'off'
                                }
                            }, {
                                'featureType': 'green',
                                'elementType': 'all',
                                'stylers': {
                                    'visibility': 'off'
                                }
                            }, {
                                'featureType': 'subway',
                                'elementType': 'all',
                                'stylers': {
                                    'visibility': 'off'
                                }
                            }, {
                                'featureType': 'manmade',
                                'elementType': 'all',
                                'stylers': {
                                    'visibility': 'off',
                                    'color': '#d1d1d1'
                                }
                            }, {
                                'featureType': 'local',
                                'elementType': 'all',
                                'stylers': {
                                    'visibility': 'off',
                                    'color': '#d1d1d1'
                                }
                            }, {
                                'featureType': 'arterial',
                                'elementType': 'labels',
                                'stylers': {
                                    'visibility': 'off'
                                }
                            }, {
                                'featureType': 'boundary',
                                'elementType': 'all',
                                'stylers': {
                                    'color': '#fefefe'
                                }
                            }, {
                                'featureType': 'building',
                                'elementType': 'all',
                                'stylers': {
                                    'visibility': 'off',
                                    'color': '#d1d1d1'
                                }
                            }, {
                                'featureType': 'label',
                                'elementType': 'labels.text.fill',
                                'stylers': {
                                    'color': '#999999'
                                }
                            }]
                        }
                    },
                    series: [
                        {
                            name: '开班数量',
                            type: 'scatter',
                            coordinateSystem: 'bmap',
                            zoom: 1.2,
                            data: [
                                {
                                    name: '鄂尔多斯',
                                    itemStyle: {
                                        normal: {    //是图形在默认状态下的样式
                                            label: {
                                                show: true,
                                                textStyle: {color: "rgb(249, 249, 249)"}
                                            },
                                            areaColor: '#fff',
                                            borderColor: '#0692a4'
                                        },
                                    },
                                    value: [109.781327, 39.608266, 800]
                                }
                            ],
                            symbolSize: function (val) {
                                return val[2] / 10;
                            },
                            encode: {
                                value: 2
                            },
                            label: {
                                formatter: '{b}',
                                position: 'right',
                                show: false,
                            },
                            emphasis: {
                                label: {
                                    show: true
                                },
                                itemStyle: {
                                    color: '#FFFFFF'
                                }
                            }
                        }
                    ]
                },

                // 折线图表统一配置
                lineEchartOption: {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        show: true,
                        textStyle: {
                            color: '#61a8ff'
                        },
                        data: [],
                    },
                    grid: {
                        left: '3%',
                        right: '7%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#61a8ff',
                                width: 1,
                                type: 'solid'
                            }
                        },
                        data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
                    },
                    yAxis: {
                        type: 'value',
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#61a8ff',
                                width: 1,
                                type: 'solid'
                            }
                        },
                        nameTextStyle: {
                            color: ['#FFFFFF']
                        }
                    },
                    series: []
                },

                // 纵向柱状图配置
                barEchartOption: {
                    // title: {
                    //     text: '',
                    //     subtext: ''
                    // },
                    xAxis: {
                        data: [],
                        axisLabel: {
                            inside: false,  // 横轴图例文字位置（true在bar上）
                            textStyle: {
                                color: '#61a8ff'
                            }
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#61a8ff',
                                width: 1,
                                type: 'solid'
                            }
                        },
                        axisTick: {
                            show: true
                        },
                        z: 10
                    },
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    dataZoom: [
                        {
                            type: 'inside'
                        }
                    ],
                    series: [
                        {
                            type: 'bar',
                            // itemStyle: {
                            //     color: new echarts.graphic.LinearGradient(
                            //         0, 0, 0, 1,
                            //         [
                            //             { offset: 0, color: '#00fffb' }, // 0 起始颜色
                            //             { offset: 1, color: '#0061ce' }  // 1 结束颜色
                            //         ]
                            //     )
                            // },
                            emphasis: {
                                itemStyle: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 0, 1,
                                        [
                                            {offset: 0, color: '#2378f7'},
                                            {offset: 0.7, color: '#2378f7'},
                                            {offset: 1, color: '#83bff6'}
                                        ]
                                    )
                                }
                            },
                            data: [],
                        }
                    ]
                },

                // 多Y轴echar统一配置信息
                doubleYaxisEcharts: {
                    color: ['#68d8fe', '#91CC75', '#EE6666'],
                    // 提示线
                    tooltip: {
                        trigger: 'axis',
                        // formatter: '{b}<br />{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}%',
                        formatter: function (params) {
                            let str = '';
                            params.forEach((item, idx) => {
                                str += `${item.marker}${item.seriesName}: ${item.data}`
                                switch (idx){
                                    case 0:
                                        str += '人';
                                        break;
                                    case 1:
                                        str += '人';
                                        break;
                                    case 2:
                                        str += '%';
                                        break;
                                    default:
                                        str += ''
                                }
                                str += idx === params.length -1? '': '<br/>';
                                if (!idx) {
                                    str =  (item.name + '<br/>') + str;
                                }
                            });
                            return str;
                        },
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    // 位置
                    grid: {
                        right: '15%',
                        left: '15%'
                    },
                    legend: {
                        data: ['通过人数', '未通过人数', '通过率'],
                        textStyle: {
                            color: '#61a8ff'
                        }
                    },
                    xAxis: [
                        {
                            type: 'category',
                            axisTick: {
                                alignWithLabel: false
                            },
                            data: [],
                            axisLabel: {
                                inside: false,  // 横轴图例文字位置（true在bar上）
                                textStyle: {
                                    color: '#61a8ff'
                                }
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: '#61a8ff',
                                    width: 1,
                                    type: 'solid'
                                }
                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            name: '人数',
                            position: 'right',
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: '#68d8fe'
                                }
                            },
                            axisLabel: {
                                formatter: '{value} '
                            }
                        },
                        {
                            type: 'value',
                            name: '通过率',
                            min: 0,
                            max: 100,
                            position: 'center',
                            splitLine: {
                                show: false,
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: '#EE6666'
                                }
                            },
                            axisLabel: {
                                formatter: '{value} %'
                            }
                        },
                    ],
                    series: []
                },

                // 饼图同意配置信息
                pieOption: {
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        bottom: 10,
                        left: 'left',
                        textStyle: {
                            color: '#61a8ff'
                        }
                    },
                    series: [
                        {
                            name: '会员协会培训班统计',
                            type: 'pie',
                            radius: '50%',
                            bottom: '20%',
                            center: [ '50%', '40%'],
                            data: [],
                            label: {
                                formatter: '{b}:{c}',
                                position: 'top',
                                show: true,
                            },
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                },

                chinaMapByBMP: null
            }
        },

        filters: {
            formateType(val) {
                let tips = '';
                switch (val) {
                    case 'approve':
                        tips = '审核培训班';
                        break;
                    case  'adjust':
                        tips = '调整学员名单';
                        break;
                    case  'submit_class':
                        tips = '提交培训班';
                        break;
                    case  'submite_score':
                        tips = '提交成绩';
                        break;
                    case  'audit_score':
                        tips = '审核成绩';
                        break;
                    default:
                        tips = '--';
                        break;
                }
                return tips;
            },
            formateStatus(val) {
                let tips = '';
                switch (val) {
                    case 'wait':
                        tips = '待审核';
                        break;
                    case  'pass':
                        tips = '通过';
                        break;
                    case  'repulse':
                        tips = '拒绝';
                        break;
                    default:
                        tips = '--';
                        break;
                }
                return tips;
            },
        },

        async mounted() {
            const that = this;
            this.fullscreenLoading = true;
            await that.loadClassInfo();

            // 加载培训班数据
            // this.loadClassTable();
            this.autoLoadClassTable();
            // 加载教案数据
            await that.loadTutorialAll();
            // 加载用户登录
            await this.loadUserLoginData();
            that.autoChangeLoginUser();
            // that.autoChangeTutorialEchart();
            that.autoChangeSelectCoachIndex();  // 自动切换协会内容
            that.draw();
            window.onresize = debounce(function () {
                // 自动调整绘画区域大小
                that.echartsList.forEach(item => {
                    item();
                });

            }, 100, false);
            this.fullscreenLoading = false;


        },

        destroyed() {
            clearInterval(this.coachAutoChangeTimer)
            clearInterval(this.coachAutoChangeTimer);
            clearInterval(this.userLoginTimer);
            clearInterval(this.userLoginTimer);
            clearInterval(this.tableTimer);
            if(this.chinaMapByBMP) {
                this.$nextTick(() => {
                    this.chinaMapByBMP.dispose()
                    this.chinaMapByBMP = null
                })
            }
        },

        methods: {

            // 手动 - 全屏方法
            // requestFullScreen() {
            //     const element = document.documentElement;
            //     const requestMethod = element.requestFullScreen ||
            //         element.webkitRequestFullScreen ||
            //         element.mozRequestFullScreen ||
            //         element.msRequestFullScreen;
            //     if(requestMethod) {
            //         requestMethod.call(element);
            //         console.log('fullscreen is done');
            //     } else if (typeof window.ActiveXObject !== 'undefined' ) {
            //         var wscript = new ActiveXObject("WScript.Shell");
            //         if (wscript !== null) {
            //             wscript.SendKeys("{F11}");
            //         }
            //     }
            //     else {
            //         console.log('no request function');
            //     }
            // },

            // vue-fullscreen 组件
            toggle () {
                this.fullscreen = !this.fullscreen;
            },
            toggleApi () {
                const that = this;
                this.$fullscreen.toggle(this.$el.querySelector('.fullscreen-wrapper'), {
                    teleport: this.teleport,    // 如果为true， 进入全屏时目标元素会被移动到document.body下；
                    callback: (isFullscreen) => {
                        that.fullscreen = isFullscreen
                    },
                })
            },

            // 手动检测全屏状态
            isFullNow(){
                let isFull = document.fullscreenEnabled || window.fullScreen || window.webkitIsFullScreen || document.msFullscreenEnabled;
                if(isFull === undefined) isFull = false;
                return isFull;
            },
    
            async yearChange() {
                const that = this;
                this.allCoachName = 0;
                this.allCoachNamezhuanxiang = 0;
                this.allCoachNamePhysical = 0;
                this.fullscreenLoading = true;
                await that.loadClassInfo();
                // 加载培训班数据
                // this.loadClassTable();
                this.autoLoadClassTable();
                // 加载教案数据
                await that.loadTutorialAll();
                // 加载用户登录
                await this.loadUserLoginData();
                that.autoChangeLoginUser();
                // that.autoChangeTutorialEchart();
                that.autoChangeSelectCoachIndex();  // 自动切换协会内容
                that.draw();
                window.onresize = debounce(function () {
                    // 自动调整绘画区域大小
                    that.echartsList.forEach(item => {
                        item();
                    });
        
                }, 100, false);
                this.fullscreenLoading = false;
            },

            // 手动切换培训班
            coachChange() {
              //   coachAutoChangeTimer: null, // 会员协会默认切换
              //   changeTimer: null,
              if(this.coachAutoChangeTimer) clearInterval(this.coachAutoChangeTimer);
              if(this.changeTimer) clearTimeout(this.changeTimer);

              this.changeTimer = setTimeout(() => {
                  this.autoChangeSelectCoachIndex()
              })
            },
            // 切换显示当前足协显示数据 selectCoachIndex   coachAutoChangeTimer
            autoChangeSelectCoachIndex() {
                if(this.coachAutoChangeTimer) clearInterval(this.coachAutoChangeTimer);
                 this.coachAutoChangeTimer = setInterval(()=> {
                     this.selectCoachIndex = this.selectCoachIndex + 1;
                 },4000)
            },

            // 使用中国地图 = 省数据映射
            drawMap() {
                // echart-map
                const CHINA = require("./mapJSON/chinaall.json"); // 中国
                echarts.registerMap("中国地图", CHINA);
                const mapDom = document.getElementById("echart-map");
                let chinaMapChart = echarts.init(mapDom)
                let optionChinaMap = this.chinaMapOption;
                const {series} = optionChinaMap;
                series[0].data = this.chinaMapData;
                let seriesObj = {
                    ...series[0],
                    data: this.chinaMapData
                }
                optionChinaMap = Object.assign({}, optionChinaMap, {series: [seriesObj]});
                this.echartsList.push(chinaMapChart.resize)
                chinaMapChart.clear()
                this.chinaMapByBMP = chinaMapChart;
                chinaMapChart.setOption(optionChinaMap);
            },

            // 使用百度地图 = 数据映射
            draw_bmap() {
                const mapDom = document.getElementById("echart-map");
                let chinaMapChart = echarts.init(mapDom)
                this.echartsList.push(chinaMapChart.resize)
                let optionChinaMap = this.bmapOption;
                chinaMapChart.setOption(optionChinaMap);

            },

            // 绘制教练员成绩分析统计图表
            draw_tutorial_add(timeFlag) {
                if (!timeFlag) timeFlag = 'week';
                const { xAxisData,passSeriesData, failSeriesData, passRateSeriesData } = this.formateCoachData2EchartsData()
                let options = this.doubleYaxisEcharts;
                let xAxisConfig = options['xAxis'][0];
                xAxisConfig.data = xAxisData;
                let series = [
                    {
                      name: '通过人数',
                      type: 'bar',
                      data: passSeriesData,
                      label: {
                        show: true,
                        position: "top",
                        distance: 5,
                        align: "center",
                        verticalAlign: "middle",
                      },
                    },
                    {
                      name: '未通过人数',
                      type: 'bar',
                      data: failSeriesData,
                      label: {
                        show: true,
                        position: "top",
                        distance: 5,
                        align: "center",
                        verticalAlign: "middle",
                      },
                    },
                    {
                      name: '通过率',
                      type: 'line',
                      yAxisIndex: 1,
                      data: passRateSeriesData,
                      label: {
                        show: true,
                        position: "top",
                        distance: 5,
                        align: "center",
                        verticalAlign: "middle",
                        formatter: function(val) {
                            const labels = `${val.value}%`
                            return labels
                        }
                        },
                    },
                ];
                options = Object.assign({},options, { xAxis:xAxisConfig, series } );

                const mapDom = document.getElementById("echart-tutorial-add");
                let tutorial_add = echarts.init(mapDom);
                this.echartsList.push(tutorial_add.resize);
                tutorial_add.setOption(options);
            },
            // 教练员成绩分析原始数据处理
            formateCoachData2EchartsData() {
                const { passCoachCount, failCoachCount, totalCoachCount} = this.coachCount;
                let xAxisData = [ 'PRO','A','B','C','D'],passSeriesData = [], failSeriesData = [], passRateSeriesData = [];
                const passCoachCountMap = this.formateArryData2MapObj(passCoachCount);
                const failCoachCountMap = this.formateArryData2MapObj(failCoachCount);
                const totalCoachCountMap = this.formateArryData2MapObj(totalCoachCount);
                xAxisData.forEach((item,i) => {
                    // 处理通过数据
                    const passItemCount = passCoachCountMap[item] ? passCoachCountMap[item] : 0;
                    passSeriesData.push(passItemCount);
                    // 处理未通过数据
                    const failItemCount = failCoachCountMap[item] ? failCoachCountMap[item] : 0;
                    failSeriesData.push(failItemCount);
                    // 处理通过率数据
                    const passRateItemCount = parseInt(( passCoachCountMap[item]/totalCoachCountMap[item]  ) * 100) || 0
                    passRateSeriesData.push(passRateItemCount)
                });
                xAxisData.splice(0,1,'职业');
                xAxisData = xAxisData.map(item => {
                   return  (item + '级')
                });
                return { xAxisData,passSeriesData, failSeriesData, passRateSeriesData }
            },
            // 将Array转化为map对象；
            formateArryData2MapObj(arr) {
                let mapObj = {};
                if(arr.length) {
                    arr.forEach(item => {
                        mapObj[item.class_level] =  item.num
                    })
                }
                return mapObj;
            },

            // 绘制用户登录数量统计图表
            draw_user_login(timeFlag) {
                if (!timeFlag) timeFlag = 'month';
                const {xAxisData, seriesData} = this.loginEchartData;
                // 设置图例
                let legend = {
                    data: [],
                    show: true,
                    textStyle: {
                        color: '#61a8ff'
                    },
                };
                // 设置横向坐标
                let xAxis = {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#61a8ff',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    data: xAxisData
                };
                // 设置数据
                let series = [
                    {
                        name: '用户登录数量',
                        type: 'line',
                        stack: '总量',
                        data: seriesData
                    },
                ];
                let color = [
                    '#68d8fe', '#fac858', '#ee6666', '#73c0de'
                ];
                const options = Object.assign({}, this.lineEchartOption, {legend, xAxis, series, color});
    
                const mapDom = document.getElementById("echart-user-login");
                let user_login = echarts.init(mapDom);
                this.echartsList.push(user_login.resize);
                user_login.setOption(options);
            },

            // 绘制会员协会用户总量统计图表
            draw_associate_all() {
                let {xAxis} = this.barEchartOption;
                const {xAxisData, groupRankTypeSeriesData} = this.vipUserCountEchartData;
                let tooltip = {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                };
                // 设置图例
                let legend = {
                    data: ['教练员总数量'],
                    show: true,
                    textStyle: {
                        color: '#61a8ff'
                    },
                };
                // 设置横向坐标
                xAxis = Object.assign({}, xAxis, {data: xAxisData});

                let series = [
                    {
                        name: '教练员总数量',
                        type: 'bar',
                        barwidth: '80%',
                        data: groupRankTypeSeriesData,
                        label: {
                            show: true,
                            position: 'top',
                            distance: 5,
                            align: 'center',
                            verticalAlign: 'middle',
                        }
                    },
                ];
                let color = [
                    '#68d8fe', '#fac858', '#ee6666', '#73c0de'
                ];
                let yAxis = [
                    {
                        type: 'value',
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#61a8ff',
                                width: 1,
                                type: 'solid'
                            }
                        },
                        nameTextStyle: {
                            color: ['#FFFFFF']
                        }
                    }
                ];
                let grid = {
                    left: '12%',
                  height: "70%",
                  width:"90%"
                };
                const options = Object.assign({}, this.barEchartOption, {tooltip, grid, xAxis, yAxis, series, color});
                const mapDom = document.getElementById("echart-associate-all");
                let associate_all = echarts.init(mapDom);
                this.echartsList.push(associate_all.resize);
                associate_all.setOption(options);
                
            },
            // 绘制会员协会用户总量统计图表 专项
            draw_associate_zhuanxiang() {
                let {xAxis} = this.barEchartOption;
                const {XgroupGoalieRankTypeSeriesData, groupGoalieRankTypeSeriesData} = this.vipUserCountEchartDataZhuanxiang;
                let tooltip = {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                };
                // 设置图例
                let legend = {
                    data: ['教练员总数量'],
                    show: true,
                    textStyle: {
                        color: '#61a8ff'
                    },
                };
                // 设置横向坐标
                xAxis = Object.assign({}, xAxis, {data: XgroupGoalieRankTypeSeriesData});

                let series = [
                    {
                        name: '教练员总数量',
                        type: 'bar',
                        barwidth: '80%',
                        data: groupGoalieRankTypeSeriesData,
                        label: {
                            show: true,
                            position: 'top',
                            distance: 5,
                            align: 'center',
                            verticalAlign: 'middle',
                        }
                    },
                ];
                let color = [
                    '#68d8fe', '#fac858', '#ee6666', '#73c0de'
                ];
                let yAxis = [
                    {
                        type: 'value',
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#61a8ff',
                                width: 1,
                                type: 'solid'
                            }
                        },
                        nameTextStyle: {
                            color: ['#FFFFFF']
                        }
                    }
                ];
                let grid = {
                    left: '12%',
                  height: "70%",
                  width:"90%"
                };
                const options = Object.assign({}, this.barEchartOption, {tooltip, grid, xAxis, yAxis, series, color});
                const mapDom = document.getElementById("echart-associate-all1");
                let associate_all = echarts.init(mapDom);
                this.echartsList.push(associate_all.resize);
                associate_all.setOption(options);
                
            },

            // 绘制会员协会培训班统计表
            draw_class_status() {

                // 设置图例
               const { series } = this.pieOption;
                const sourceSeries = series[0];
                const { seriesData, title} = this.formateSourceData2PieData();
                sourceSeries.data = seriesData;
                // let titleConfig = {
                //     text: title,
                //     left: 'center',
                //     textStyle: {
                //         // color: '#00f2f1'
                //         color: '#FFFFFF',
                //         fontSize: 15
                //     }
                //
                // };
                let color = [
                    '#68d8fe', '#fac858', '#ee6666', '#73c0de'
                ];
                const options = Object.assign({}, this.pieOption, { series:[sourceSeries], color})

                const mapDom = document.getElementById("echart-class-status");
                let class_status = echarts.init(mapDom);
                this.echartsList.push(class_status.resize)
                class_status.setOption(options);
            },

            // 会员协会培训班统计表数据转化pie饼图数据
            formateSourceData2PieData() {
                const {xAxisData, y_Audit, y_Complete, y_Finalised, y_Incomplete, y_Initiated, y_ScoreAudit} = this.vipClassEchartsData;

                const selectCoachIndex = this.selectCoachIndex;
                if(selectCoachIndex >= xAxisData.length) {
                    this.selectCoachIndex = 0;
                }
                const seriesData = [
                    {value: y_Audit[selectCoachIndex], name: '审核中'},
                    {value: y_Initiated[selectCoachIndex], name: '未开班'},
                    {value: y_Incomplete[selectCoachIndex], name: '进行中'},
                    {value: y_Finalised[selectCoachIndex], name: '未提交成绩'},
                    {value: y_ScoreAudit[selectCoachIndex], name: '成绩审核中'},
                    {value:  y_Complete[selectCoachIndex], name: '培训班已完成'}
                ];
                const title = xAxisData[selectCoachIndex];
                return { seriesData, title};
            },

            formateYName(val) {
                let tips = '';
                switch (val) {
                    case 'y_Audit':
                        tips = '审核中';
                        break;
                    case 'y_Complete':
                        tips = '已完成';
                        break;
                    case 'y_Finalised':
                        tips = '成绩未提交';
                        break;
                    case 'y_Incomplete':
                        tips = '进行中';
                        break;
                    case 'y_Initiated':
                        tips = '未开始';
                        break;
                    case 'y_ScoreAudit':
                        tips = '成绩审核中';
                        break;
                    default:
                        tips = '';
                        throw new Error('数据获取匹配错误！');
                        break;
                }
                return tips;
            },
            // 绘制大屏
            draw() {
                // 绘制中国地图
                this.drawMap();
                // this.draw_bmap();

                // 绘制新增教案图表
                this.draw_tutorial_add();

                // 绘制用户登陆统计
                this.draw_user_login();

                // 绘制会员协会用户总量统计
                this.draw_associate_all();
              
                // 绘制会员协会用户总量统计
                this.draw_associate_zhuanxiang();

                // 绘制会员协会培训班统计
                this.draw_class_status();
            },

            // 培训班监控切换状态
            handleClassNavClick(idx) {
                if (idx) {
                    this.classNav = +idx;
                    if (idx === 0) this.classStatusList = this.coachMonitoring;
                    if (idx === 1) this.classStatusList = this.teacherMonitoring;
                    if (idx === 2) this.classStatusList = this.dataClass;
                    if (idx === 3) this.classStatusList = this.dataScore;
                } else {
                    // 意外情况下激活0
                    this.classNav = 0;
                    this.classStatusList = this.coachMonitoring;
                }

            },

            // 新增教案切换显示状态
            handleAddedTutorialChange(val) {
                if (this.tutorialTimer) clearInterval(this.tutorialTimer);
                // this.formateData2EchartsLine(val);
                this.tutorialAddedNav = val;
                setTimeout(() => {
                    this.autoChangeTutorialEchart();
                }, 10000)
            },

            // 用户登录数量汇总
            handleLoginDataNavChange(val) {
                if (this.userLoginTimer) clearInterval(this.userLoginTimer);
                if(this.clickTimer) clearTimeout(this.clickTimer);
                this.formateLoginData2EchartsLineData(val);
                this.userLoginNav = val;
                this.clickTimer = setTimeout(() => {
                     this.autoChangeLoginUser();
                }, 10000)
            },

            // 自动更换用户登录表格
            autoChangeLoginUser() {
                if (this.userLoginTimer) clearInterval(this.userLoginTimer);    // 保证只存在一个定时器
                // const userLoginNavList = ['day', 'week', 'month', 'year',];
                const userLoginNavList = ['day', 'month', 'year',];
                // const userLoginNavList = ['day', 'week', 'month'];
                const that = this;
                let count = 0;
                that.userLoginTimer = setInterval(function () {
                    count++;
                    if (count > 2) count = 0;
                    // that.tutorialAddedNav = tutorialNavList[count];
                    that.userLoginNav = userLoginNavList[count];
                }, 10000);
            },

            // 自动切换新增教案图表
            autoChangeTutorialEchart() {
                const tutorialNavList = ['week', 'month', 'year',];
                const that = this;
                let count = 0;
                that.tutorialTimer = setInterval(function () {
                    count++;
                    if (count > 2) count = 0;
                    that.tutorialAddedNav = tutorialNavList[count];
                }, 3000);
            },

            // 加载培训班相关数据信息
            async loadClassInfo() {
                try {
                    const {data} = await getDisplayClassAllInfo({year:this.year});
                    if (data.status !== 0) {
                        this.$message.error(data.msg);
                        return
                    }
                    const {classToOrgan, classToProvince, numStatistical,numStatisticalStu} = data.result;
                    // 处理中国地图数据
                    const mapData = this.formateData2MapData(classToProvince);
                    this.chinaMapData = mapData;

                    // 处理培训班统计数据
                    this.numStatistical = numStatistical;
                    this.numStatisticalStu = numStatisticalStu;

                    // 处理协会培训班方法
                    this.formateDate2EchartsBarData(classToOrgan)
                } catch (e) {
                    console.error(e)
                }
            },

            // 将原始数据转化为地图数据
            formateData2MapData(sourceData) {
                let aimData = [];
                if (!Object.keys(sourceData)) {
                    return []
                }
                for (let key in sourceData) {
                    let value = sourceData[key];
                    let name = this.formateProvinceName(key);
                    // let name = key;     // 不再处理省后缀
                    aimData.push({
                        name,
                        value
                    })
                }
                return aimData;
            },

            // 处理省字符串
            formateProvinceName(name = '') {
                return name.replace(/省|自治区|壮族自治区|回族自治区|维吾尔自治区|特别行政区/, '');
            },

            // 处理协会培训班数据转化为图表数据
            formateDate2EchartsBarData(sourceData) {
                let x_data = Object.keys(sourceData);
                if (!x_data.length) {
                    this.vipClassEchartsData = {
                        xAxisData: [],
                        y_Audit: [],
                        y_Complete: [],
                        y_Finalised: [],
                        y_Incomplete: [],
                        y_Initiated: [],
                        y_ScoreAudit: []
                    };
                    return
                }
                let y_Audit = [];
                let y_Complete = [];
                let y_Finalised = [];
                let y_Incomplete = [];
                let y_Initiated = [];
                let y_ScoreAudit = [];
                for (let key in sourceData) {
                    y_Audit.push(sourceData[key]['Audit']);
                    y_Complete.push(sourceData[key]['Complete']);
                    y_Finalised.push(sourceData[key]['Finalised']);
                    y_Incomplete.push(sourceData[key]['Incomplete']);
                    y_Initiated.push(sourceData[key]['Initiated']);
                    y_ScoreAudit.push(sourceData[key]['ScoreAudit']);
                }
                this.echartsBarX = x_data;
                let coachList = [];
                x_data.forEach((item,i)=> {
                    coachList.push({
                        label: item,
                        value: i
                    })
                });
                this.coachList = coachList;
                this.echartsBarYData = {y_Audit, y_Complete, y_Finalised, y_Incomplete, y_Initiated, y_ScoreAudit};
                this.vipClassEchartsData = {
                    xAxisData: x_data,
                    y_Audit,
                    y_Complete,
                    y_Finalised,
                    y_Incomplete,
                    y_Initiated,
                    y_ScoreAudit
                };
            },

            // 加载监控培训班
            loadClassTable(params) {
                let submiteData = {};
                if(params) {
                     submiteData = {
                        type: params
                    }
                }
                getDisplayClassTable(submiteData)
                    .then(({data}) => {
                        if (data.status !== 0) {
                            this.$message.error(data.msg);
                            return
                        }
                        const {dataClass, dataScore, onlineCoachCount, eventCoachCount, coachMonitoring, teacherMonitoring } = data.result;
                        if(dataClass) this.dataClass = dataClass;
                        if(dataScore) this.dataScore = dataScore;
                        if(coachMonitoring) this.coachMonitoring = coachMonitoring;
                        if(teacherMonitoring) this.teacherMonitoring = teacherMonitoring;
                        this.onlineCoachCount = onlineCoachCount;
                        this.eventCoachCount = eventCoachCount;
                        if(!this.classStatusList.length) this.classStatusList = coachMonitoring;
                    }).catch(err => {
                    console.error(err)
                })
            },

            // 自动定时获取培训班监控数据
            autoLoadClassTable() {
              const that = this;
              if (that.tableTimer) clearInterval(that.tableTimer)
              that.loadClassTable();
              let loadParams = that.getClassDataFilters();
              that.tableTimer = setInterval(() => {
                  that.loadClassTable(loadParams);
              },20000)
            },
            // 获取参数
            getClassDataFilters() {
                const nowIndex = this.classNav;
                let tips = '';
                switch (nowIndex) {
                    case 0:
                       tips = 'coachMonitoring';
                       break;
                    case 1:
                       tips = 'teacherMonitoring';
                       break;
                    case 2:
                       tips = 'dataClass';
                       break;
                    case 3:
                       tips = 'dataScore';
                       break;
                }
                return tips;
            },
            // 加载教案统计
            async loadTutorialAll() {
                try {
                    const {data} = await getTutorialAll();
                    if (data.status !== 0) {
                        this.$message.error(data.msg);
                        return
                    }
                    const {planCount, ...rest} = data.result;
                    this.planCount = planCount;
                    this.planInfo = rest;
                    this.formateData2EchartsLine('week')
                } catch (e) {
                    console.error(e)
                }
            },

            // 将原始教案数据转化为echart数据
            formateData2EchartsLine(status) {
                if (!status) status = 'week';
                const sourceData = this.planInfo;
                let sourceExam = [], sourcePractice = [];
                let x_data = this.constructTimeSequelize2EchartsXAxis(status);

                /* 生成横坐标 end */
                switch (status) {
                    case 'week':
                        sourceExam = sourceData['planInfoWeekExam'] || [];
                        sourcePractice = sourceData['planInfoWeekPractice'] || [];
                        // x_data = week_x_data;
                        break;
                    case 'month':
                        sourceExam = sourceData['planInfoMonthExam'] || [];
                        sourcePractice = sourceData['planInfoMonthPractice'] || [];
                        // x_data = month_x_data;
                        break;
                    case 'year':
                        sourceExam = sourceData['planInfoYearExam'] || [];
                        sourcePractice = sourceData['planInfoYearPractice'] || [];
                        // x_data = year_x_data;
                        break;
                    default:
                        throw  new Error('函数使用方式错误：formateData2EchartsLine;正确传参');
                        break;
                }
                let source_map_exam = {};
                sourceExam.forEach(item => {
                    source_map_exam[item.MONTH] = item.MINUTE
                });
                let source_map_exam_series = [];
                for (let i = 0; i < x_data.length; i++) {
                    let value = source_map_exam[x_data[i]] ? source_map_exam[x_data[i]] : 0;
                    source_map_exam_series.push(value)
                }

                let source_map_practice = {};
                sourcePractice.forEach(item => {
                    source_map_practice[item.MONTH] = item.MINUTE
                });
                let source_map_practice_series = [];
                for (let i = 0; i < x_data.length; i++) {
                    let value = source_map_practice[x_data[i]] ? source_map_practice[x_data[i]] : 0;
                    source_map_practice_series.push(value)
                }

                this.planInfoEchartsRenderData = {x_data, source_map_exam_series, source_map_practice_series}
            },

            // 生成时间序列，用来做填充echart数据的基础模板
            constructTimeSequelize2EchartsXAxis(status = '') {
                let xAxis = [];
                switch (status) {
                    case "day":
                        for (let i = 0; i < 30; i++) {
                            let unshiftDate = moment().subtract(i+1, 'days').format('yyyy-MM-DD');
                            xAxis.unshift(unshiftDate);
                        }
                        break;
                    case "week":
                        for (let i = 0; i < 7; i++) {
                            let unshiftDate = moment().subtract(i, 'days').format('yyyy-MM-DD');
                            xAxis.unshift(unshiftDate);
                        }
                        break;
                    case "month":
                        for (let i = 0; i < 12; i++) {
                            let unshiftDate = moment().subtract(i+1, 'months').format('yyyy-MM');
                            xAxis.unshift(unshiftDate);
                        }
                        break;
                    case "year":
                        for (let i = 0; i < 4; i++) {
                            let unshiftDate = moment().subtract(i, 'years').format('yyyy');
                            xAxis.unshift(unshiftDate);
                        }
                        break;
                }
                if (xAxis.length) {
                    return xAxis;
                } else {
                    return false
                }
            },

            // 加载用户登录统计
            async loadUserLoginData() {
                try {
                    const {data} = await getUserLoginData({year:this.year});
                    if (data.status !== 0) {
                        this.$message.error(data.msg);
                        return
                    }
                    let {loginInfoCount, userCount, userRankCount, ...coachCount} = data.result;
                    this.coachCount = coachCount;   // 教练员成绩原始数据
                    this.loginInfoCount = JSON.parse(loginInfoCount);
                    // 处理用户登录数量汇总图表
                    this.formateLoginData2EchartsLineData('day');
                    this.userCount = userCount;
                    this.userInfoOrganization = userRankCount;
                    // 处理会员协会用户总量统计
                    this.formateVipUserData2EchartsLineData();

                } catch (e) {
                    console.error(e)
                }
            },

            // 将原始用户登录统计数据转化为echart数据
            formateLoginData2EchartsLineData(status) {
                let sourceData = this.loginInfoCount;
                const xAxisData = this.constructTimeSequelize2EchartsXAxis(status);
                let sourceSeriesData = [];
                switch (status) {
                    case 'day':
                        sourceSeriesData = sourceData['loginInfoDay'] || [];
                        break;
                    case  'week':
                        sourceSeriesData = sourceData['loginInfoWeek'] || [];
                        break;
                    case  'month':
                        sourceSeriesData = sourceData['loginInfoMonth'] || [];
                        break;
                    case  'year':
                        sourceSeriesData = sourceData['loginInfoYear'] || [];
                        break;
                }
                // 转化'字典'对象
                let sourceSeriresMapData = {};
                if (sourceSeriesData.length) {
                    sourceSeriesData.forEach(item => {
                        sourceSeriresMapData[item.MONTH] = item.MINUTE
                    });
                }
                let aimSeriesData = [];
                xAxisData.forEach(item => {
                    let res = sourceSeriresMapData[item] ? sourceSeriresMapData[item] : 0;
                    aimSeriesData.push(res)
                });
                this.loginEchartData = {xAxisData, seriesData: aimSeriesData}
            },

            // 会员协会用户总量统计数据转化
            formateVipUserData2EchartsLineData() {
              console.log(this.userInfoOrganization)
                const {groupRankType, groupRankTypeActive,groupGoalieRankType,groupPhysicalRankType} = this.userInfoOrganization;
                let xAxisData = [], groupRankTypeSeriesData = [], groupRankTypeActiveSeriesData = [],groupGoalieRankTypeSeriesData = [],XgroupGoalieRankTypeSeriesData = [],groupPhysicalRankTypeSeriesData = [],XgroupPhysicalRankTypeSeriesData = [];
                if (groupRankType.length && groupRankTypeActive.length) {
                    groupRankType.forEach(item => {
                        const [xAxisDataItem, seriesDataItem] = item;
                      this.allCoachName = this.allCoachName + seriesDataItem; // 计算一下总量
                        xAxisData.push(xAxisDataItem);
                        groupRankTypeSeriesData.push(seriesDataItem)
                    });
                }
                xAxisData.splice(0,1,'职业');
                xAxisData = xAxisData.map(item => {
                    return  (item + '级')
                });
                this.vipUserCountEchartData = {xAxisData, groupRankTypeSeriesData};
                if (groupGoalieRankType.length) {
                  groupGoalieRankType.forEach(item => {
                        let [xAxisDataItem1, seriesDataItem1] = item;
                      this.allCoachNamezhuanxiang = this.allCoachNamezhuanxiang + seriesDataItem1; // 计算一下总量
                    
                    if(xAxisDataItem1 === 'GA'){
                      xAxisDataItem1 = '守门员A级'
                    }else if(xAxisDataItem1 === 'GB'){
                      xAxisDataItem1 = '守门员B级'
                    }else if(xAxisDataItem1 === 'GC'){
                      xAxisDataItem1 = '守门员C级'
                    }
                    XgroupGoalieRankTypeSeriesData.push(xAxisDataItem1);
                    groupGoalieRankTypeSeriesData.push(seriesDataItem1)
                    });
                }
                
                if (groupPhysicalRankType.length) {
                  groupPhysicalRankType.forEach(item => {
                        let [xAxisDataItem1, seriesDataItem1] = item;
                      this.allCoachNamePhysical = this.allCoachNamePhysical + seriesDataItem1; // 计算一下总量
                    
                    if(xAxisDataItem1 === 'F1'){
                      xAxisDataItem1 = '体能L1级'
                    }else if(xAxisDataItem1 === 'F2'){
                      xAxisDataItem1 = '体能L2级'
                    }
                    XgroupGoalieRankTypeSeriesData.push(xAxisDataItem1);
                    groupGoalieRankTypeSeriesData.push(seriesDataItem1)
                    });
                }
              this.vipUserCountEchartDataZhuanxiang = {XgroupGoalieRankTypeSeriesData, groupGoalieRankTypeSeriesData};

            
            },


        }
    }
</script>

<style lang="stylus" scoped>
    @import '~@/assets/css/variable';
    .display-wrapper
        width 100%
        height 100%
        background-color #101129 !important

    .display-content
        background-color #101129 !important
        min-width 1680px
        max-width 1920px
        /*min-height 780px*/
        margin 0 auto
        display flex
        padding 9rem 0.8rem 0
        background url("../../assets/images/display/logo.png") no-repeat 0 0 / contain;

        .column
            position relative
            flex 3

            .row
                box-sizing border-box
                border 2px solid red
                border-image url("../../assets/images/display/border.png") 51 38 21 132
                border-width 4.125rem 1.583rem 0.875rem 5.5rem
                position relative
                margin-bottom 2rem
                color #FFFFFF

            .row-content
                position: absolute
                top -4rem
                right -1.5rem
                bottom -0.875rem
                left -5.5rem
                padding 1.25rem

            .class-all
                height 150px

                .row-title
                    color #68d8fe
                    font-weight 600
                    font-size 16px
                    display flex
                    align-items center
                    .sutNum
                        font-size 12px
                        margin-left 5px
                        color #FAC858

                    .btn
                        display flex
                        align-items center
                        justify-content center
                        width 7rem
                        height 2rem
                        font-size 1rem
                        margin 0 5px
                        border-radius 2px
                        cursor pointer

                    .btn-active
                        background-color #0bace6
                        color #FFFFFF

                .data-wrapper
                    display flex
                    flex-wrap wrap

                    .data-item
                        flex 1
                        font-size 12px
                        text-align center

                        .data
                            font-size 26px
                        .num_data
                            font-size 20px !important
                            .sutNum
                                font-size 12px
                                margin-left 2px
                                

                        .data-title
                            color #4c9bfd
                            margin-top 5px

            .class-table
                height 350px

                .row-content
                    padding 1.25rem 0

                .nav-title-wrapper
                    padding-left 1.25rem
                    margin-bottom 0.8rem

                    .nav-item
                        margin-right 15px
                        cursor pointer
                        color #1950c4
                        padding-right 15px
                        border-right 2px solid #00f2f1
                        &:last-child
                            border-right none


                    .active-title
                        color #FFFFFF

                .table-wrapper
                    .table-head
                        display flex
                        width 100%
                        background-color rgba(255, 255, 255, 0.1)
                        color #68d8fe
                        padding 0 1rem
                        line-height 3rem

                        .table-column
                            /*flex 1*/
                            text-align center

                            &:nth-child(1)
                                width 20%

                            &:nth-child(2)
                                width 30%

                            &:nth-child(3)
                                width 20%

                            &:nth-child(4)
                                width 15%

                            &:nth-child(5)
                                width 15%

                    .table-content
                        height 250px
                        overflow hidden

                        .table-row
                            width 100%
                            display flex
                            padding 0 1rem
                            line-height 2.5rem
                            color #61a8ff

                            &:hover
                                background-color rgba(255, 255, 255, 0.1)
                                color #68d8fe

                            .table-col
                                white-space nowrap
                                overflow hidden
                                text-overflow ellipsis
                                text-align center

                                &:nth-child(1)
                                    width 20%

                                &:nth-child(2)
                                    width 30%

                                &:nth-child(3)
                                    width 20%

                                &:nth-child(4)
                                    width 15%

                                &:nth-child(5)
                                    width 15%

        .center
            flex 4
            margin 3.8rem 1.5rem 0

            .map-title
                color #68d8fe
                font-size 1.6rem
                text-align center

            .echart-map
                width 100%
                /*height 440px + 4.875rem*/
                height 455px
            .online
                position absolute
                top -18px
                left 0
                z-index 999
                .online-content
                    width inherit
                    height inherit
                    position absolute
                    top -40px
                    left -56px
                    display flex
                    flex-direction column
                    .title
                        width 100%
                        color: #68d8fe
                        font-size 1.6rem
                        line-height 4rem
                        text-align center
                    .content
                        flex 1
                        font-size 2.4rem
                        display flex
                        justify-content center
                        align-items center
    .table-content
        .animation-wrapper
            animation row 20s linear infinite

            &:hover
                animation-play-state paused

    .tutorial-add
        height 350px !important

        .data-wrapper
            height 90%

        .echart-tutorial-add
            width 100%
            height 100%

    .login-data
        height 340px !important

        .data-wrapper
            height 90%

        .echart-user-login
            width 100%
            height 100%

    .class-vip
        height 340px !important

        .data-wrapper
            height 90%

        .echart-class-status
            width 100%
            height 100%

    .user-all
        height 340px !important
        /*margin-top 4.6rem*/

        .flex-box
            display flex
            width 100%
            height 100%

            .flex-item
                /*flex 1 1*/
                height 100%

                .data-wrapper
                    height 90%

            .left
                flex 5

            .right
                flex 2
                padding 8rem 2rem 8rem 2rem
                display flex
                flex-direction column
                justify-content space-around
                font-size 1.4rem
                color #61a8ff
                text-align center

                .line-text
                    /*text-align left*/
                    display flex
                    justify-content space-between

                    span:nth-child(1)
                        display flex
                        align-items center
                        justify-content flex-start

                    span:nth-child(2)
                        font-size 2.5rem
                        margin-left 5px
                        color: #FFFFFF
                        text-align left
                        display block
                        width 6rem

        .echart-associate-all
            width 100%
            height 100%

    @keyframes row {
        0% {
        }
        100% {
            transform translateY(-50%)
        }
    }

    .fullscreen-btn
        color #61a8ff
        cursor pointer
    
    .tooltip {
        position: relative;
        display: inline-block;
        cursor: pointer;
    }
    .tooltiptext {
        visibility: hidden;
        width: 70px;
        height: 35px; /* 设置高度为50px */
        line-height: 35px; /* 文字垂直居中，假设单行文本 */
        background-color: rgba(50, 50, 50, 0.7);
        color: #fff;
        text-align: center;
        padding: 0; /* 移除默认padding以精确控制高度 */
        border-radius: 6px;
        font-size:13px;
        /* 改变定位使工具提示出现在右侧 */
        position: absolute;
        z-index: 1;
        top: 50%; /* 使工具提示垂直居中 */
        right: -35%; /* 放置在触发元素右侧 */
        transform: translateY(-50%); /* 通过transform实现垂直居中 */
    
        /* 添加淡入淡出效果 */
        opacity: 0;
        transition: opacity 0.3s;
    }

    /* Tooltip arrow */
    .tooltiptext::after {
        content: "";
        position: absolute;
        top: 40%; /* At the bottom of the tooltip */
        right: 100%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color:  transparent rgba(50, 50, 50, 0.7) transparent transparent;
    }

    /* Show the tooltip text when you mouse over the tooltip container */
    .tooltip:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
    }
</style>

<style lang="stylus">
    .select-wrapper
        .el-input__inner
            background-color rgba(0,0,0,0)
            border-color #0b93d5
            color #68d8fe
    /*.el-select-dropdown*/
    /*    background-color #101129 !important*/
    /*    color #FFFFFF !important*/
    /*.el-select-dropdown__item.hover, .el-select-dropdown__item:hover*/
    /*    background-color #101129 !important*/
    /*    color #FFFFFF !important*/
</style>

